export const DISCORD_INVITE_URL = "https://discord.com/invite/cqdY6SpfVR";
export const FREE_IN_BETA = true;
export const PACKAGE_JSON_FILENAME = "package.json";
export const SPEC_FILE_NAME = "SPEC.md";
export const NEW_CHAT_ID = "new-chat";
export const MAX_QUEUE_SIZE = 3;
export const BRAINSTORM_ID = "fp-brainstorm";

/**
 * "Staged" files in the filesystem do not have a project snapshot id,
 * so we use the keyword "staged-files" as the snapshot id.
 */
export const STAGED_FILES_SNAPSHOT_ID = "staged-files";
